import { render, staticRenderFns } from "./AdImportOpt.vue?vue&type=template&id=772cddc8&scoped=true"
import script from "./AdImportOpt.vue?vue&type=script&lang=js"
export * from "./AdImportOpt.vue?vue&type=script&lang=js"
import style0 from "./AdImportOpt.vue?vue&type=style&index=0&id=772cddc8&prod&lang=scss&scoped=true"
import style1 from "./AdImportOpt.vue?vue&type=style&index=1&id=772cddc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772cddc8",
  null
  
)

export default component.exports